import React, { useEffect, useContext, useState, useRef } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom';

import Moment from 'moment'

import LanguageContext from "../../../contexts/LanguageContext"

import { Box, Hidden } from '@material-ui/core'

import cardIcon from "../../../images/cardIcon.svg"
import noSoftSkillsViewerIcon from "../../../images/noSoftSkillsViewerIcon.svg"


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './SoftSkillsViewer.css'


Moment.locale('fr')

const AdminDashboardNavBar = (props, context) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  let sliderRef = useRef(null);

  const [slides, setSlides] = useState([]);
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    let efficacite = props.softSkills.filter((el) => el.family === 'efficacite')
    let communication = props.softSkills.filter((el) => el.family === 'communication')
    let leadership = props.softSkills.filter((el) => el.family === 'leadership')

    let newSlides = []
    if (efficacite.length > 0) {
      newSlides.push({
        title : languageValues?.adminDashboard?.efficaciteSkills[actLanguage],
        softSkills : efficacite,
        family : 'efficacite'
      })
    }
    if (communication.length > 0) {
      newSlides.push({
        title : languageValues?.adminDashboard?.communicationSkills[actLanguage],
        softSkills : communication,
        family : 'communication'
      })
    }
    if (leadership.length > 0) {
      newSlides.push({
        title : languageValues?.adminDashboard?.leadershipSkills[actLanguage],
        softSkills : leadership,
        family : 'leadership'
      })
    }

    setSlideIndex(0)
    setSlides(newSlides)
  }, [props.softSkills])

  const settings = {
    dots : false,
    arrows : false,
    infinite: false,
    swipeToSlide: true,
    beforeChange: (current, next) => setSlideIndex(next),
  };

  return (
    <>
      {(props.dataLoaded === true && props.softSkills.length > 0 && slides[slideIndex]) ? (
        <>
          <Box sx={{marginBottom:"10px"}}>
            <Box sx={{color:"text.subTitle", fontSize:["14px", "16px", "16px", "16px"]}}>
              {languageValues?.adminDashboard?.usedSoftSkills[actLanguage]}
            </Box>
            <Box sx={{marginTop:"8px", color:"text.black", fontSize:["20px", "24px", "24px", "24px"]}}>
              {slides[slideIndex].title}
            </Box>
          </Box>
          <Slider ref={slider => { sliderRef = slider; }} slidesToShow={1} slidesToScroll={1} className="softskillsviewer" {...settings}>
            {slides.map((item, i) => (
              <div key={i} style={{width:'100%', height:"100%"}}>
                <Box sx={{overflow:"hidden", display:"flex", flexDirection:"column", flexWrap:"wrap", justifyContent:"space-evenly", gap:"10px", width:"100%", height:"100%", flex:1}}>
                  {item.softSkills.map((skill, i2) => {
                    return (
                      <Box key={i2} sx={{
                        display:"flex",
                        alignItems:"center",
                        gap:"10px"
                      }}>
                        <Box sx={{
                          width:["35px", "30px", "30px", "45px"],
                          minWidth:["35px", "30px", "30px", "45px"],
                        }}>
                          <img src={cardIcon} style={{width:"100%"}}/>
                        </Box>
                        <Box sx={{
                          color:"text.black",
                          textTransform: "capitalize",
                          fontSize:["15px","18px","18px","20px"],
                        }}>
                          {skill.key}
                        </Box>
                      </Box>
                    )
                  })}
                </Box>
              </div>
            ))}
          </Slider>
          <Box sx={{display:'flex', gap:"3px", marginTop:"10px", justifyContent:"center"}}>
              {Array(slides.length).fill().map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    cursor:"pointer",
                    width: i === slideIndex ? "20px" : "15px",
                    height:"3px",
                    background: i === slideIndex ? "#0A0A0B" : "rgba(10, 10, 11, 0.15)",
                  }}
                  onClick={() => { sliderRef.slickGoTo(i) }}
                />
              ))}
          </Box>
        </>
      ) : (
        <Box sx={{flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"15px", paddingBottom:["15px", "0px"]}}>
          <Box sx={{
            width:["50px", "60px", "60px", "75px"],
            minWidth:["50px", "60px", "60px", "75px"],
          }}>
            <img src={noSoftSkillsViewerIcon} style={{width:"100%"}}/>
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["20px", "24px", "24px", "26px"],
            textAlign:"center",
          }}>
            {languageValues?.adminDashboard?.softSkillsViewer?.emptyTitle[actLanguage]}
          </Box>
          <Box sx={{
            color:"text.subTitle",
            fontSize:["15px", "16px", "16px", "17px"],
            textAlign:"center",
            maxWidth:"300px",
          }}>
            {languageValues?.adminDashboard?.softSkillsViewer?.emptySubTitle[actLanguage]}
          </Box>
        </Box>
      )}
    </>
  )
}


export default AdminDashboardNavBar
